import React from 'react'
import { Icon } from 'loyal-react'
import HelpItem from './HelpItem'

export default function Recharge () {
  return (
    <div className='position-relative'>
      <div className='col-12 p-0 flex-column mt-2'>
        <div className='col-12 p-2 d-flex justify-content-between flex-column flex-md-row'>
          <div className='col-12 col-md-5'>
            <h2>Como podemos ajudar?</h2>
            <p className='my-2'>
              Encontre soluções e respostas sobre seu Cartão Like Mais
            </p>
          </div>
          <div className='col-12 col-md-6 form-field search-field'>
            <div className='box-search-field-desktop d-flex border-color-ui-3 border'>
              <label htmlFor='busca-likeplus-faq' className='hide-absolute'>Procurar no faq</label>
              <input
                className='no-label no-border radius color-ui-2'
                id='busca-likeplus-faq'
                type='text'
                placeholder='Ex: Como desbloquear meu cartão?'
                name='buscar'
                autoComplete='off'
              />
              <button
                className={`h-100 btn-sm btn btn-flat btn-icon btn-icon-only`}
                id='btn-search-loupe'
              >
                <Icon
                  iconName='icon_search'
                  className='color-brand-2'
                />
              </button>
            </div>
          </div>
        </div>
        <HelpItem />
        <HelpItem />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/Help/Help.js